const handleMobileNavigation = () => {
	const $trigger = $('.nav-tertiary .menu__item--has-dropdown > a');

	$trigger.on('click', function(event) {
		const $this = $(this);

		if (! $this.closest('li').hasClass('is-open')) {
			$this.closest('li').addClass('is-open');

			$this.siblings('.megamenu').slideDown();

			$this.closest('li').siblings().removeClass('is-open').find('.megamenu').slideUp();

			event.preventDefault();
		}
	});
}

handleMobileNavigation();
